/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCallin.ts                        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/callin";

export class AutogenModelCallin<RowType extends ModelRow> extends Endpoint<RowType, RowCallinFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCallin extends ModelRow<RowCallinFields> {
	constructor(values?: Partial<RowCallinFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCallinFields {
	actual_arrival: Date;
	actual_departure: Date;
	address: string;
	address2: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	call_date_time: Date;
	callin_script_descr: string;
	callin_script_details: string;
	callin_script_results: string;
	callin_script_template: string;
	callin_template_search_details: string;
	cases: number;
	city_id: number;
	city_name: string;
	company_id: string;
	confirmed: string;
	contact_email: string;
	contact_name: string;
	created_by: string;
	current_stop_id: string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	driver_id: string;
	driver_load_unload: string;
	edi_code: string;
	edi_loc_code: string;
	entered_by: string;
	entered_by_user_name: string;
	entered_date: Date;
	equipment_group_id: string;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	google_place_id: string;
	gps_accuracy: number;
	grouped_id: number;
	hub: number;
	ic_stop_id: string;
	id: string;
	inbound_status: string;
	initiated_type: string;
	is_required: string;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	lease_number: string;
	location_city_state: string;
	location_id: string;
	location_name: string;
	longitude: number;
	manifest_fgp_uid: number;
	manifest_reg_uid: number;
	miles2consignee: number;
	miles2consignee_um: string;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	movement_id: string;
	movement_sequence: number;
	movement_status: string;
	name: string;
	new_eta: Date;
	new_eta_time_string: string;
	next_stop_avg_speed: number;
	next_stop_city_id: number;
	next_stop_city_name: string;
	next_stop_city_state: string;
	next_stop_state: string;
	next_stop_time_left: number;
	next_stop_zip_code: string;
	operational_status: string;
	order_id: string;
	order_sequence: number;
	orig_sched_early: Date;
	orig_sched_late: Date;
	pallets_dropped: number;
	pallets_picked_up: number;
	payee_id: string;
	payment_code_reviewed: string;
	phone: string;
	planned_arrival_time: Date;
	ponum: string;
	prior_uncleared_stops: string;
	projected_arrival: Date;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	refno: string;
	remark: string;
	requested_service: string;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	sched_date_time: Date;
	seal: string;
	server_timezone: string;
	service_date: Date;
	setpoint_temp: number;
	setpoint_temp_um: string;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	signed_for_name: string;
	state: string;
	status: string;
	stop_type: string;
	tank_operator: string;
	temperature: number;
	temperature_um: string;
	tractor_id: string;
	trimble_place_id: string;
	txl_uid: number;
	type_description: string;
	volume: number;
	volume_um: string;
	weight: number;
	weight_um: string;
	zip_code: string;
	zone_id: string;
	calc_miles_eta: boolean;
	callin_date_time: string;
	callin_script_save_data: string;
	event: string;
	include_callin_script_details: boolean;
	include_positions: boolean;
	local_timezone: string;
	new_row: boolean;
	newest_first: boolean;
	next_sched_call: Date;
	remark_with_script_remarks: string;
	stop_id: string;
}

